import { render } from "./Profilo.vue?vue&type=template&id=35affb09"
import script from "./Profilo.vue?vue&type=script&lang=js"
export * from "./Profilo.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__